import { ProfilePanel } from '@/modules/profile/profile-sheet';
import { useEffect } from 'react';
import { useGetOrganisation } from '@/services/organisations/queries';

const OrganisationDetails = ({
  selectedOrganisation,
  isShowOrganisationDetails,
  setIsShowOrganisationDetails
}: {
  selectedOrganisation: string;
  isShowOrganisationDetails: boolean;
  setIsShowOrganisationDetails: (open: boolean) => void;
}) => {
  useEffect(() => {
    return () => {
      setIsShowOrganisationDetails(false);
    };
  }, [setIsShowOrganisationDetails]);

  const { data: organisation, isLoading, error } = useGetOrganisation(selectedOrganisation, {
    enabled: !!selectedOrganisation
  });


  if (isLoading && isShowOrganisationDetails) {
    return (
      <div className="flex items-center justify-center p-4">
        <p>Loading organisation details...</p>
      </div>
    );
  }

  if (error || !organisation) {
    return (
      isShowOrganisationDetails && (
        <div className="flex items-center justify-center p-4">
          <p>Failed to load organisation details</p>
        </div>
      )
    );
  }

  return (
    <ProfilePanel
      data={organisation}
      open={isShowOrganisationDetails}
      onOpenChange={setIsShowOrganisationDetails}
    />
  );
};

export default OrganisationDetails;
